import { UseFormReturn } from "react-hook-form";
import { BankingDetailsFormData } from "@/model/schemas";
import React from "react";
import { Pencil } from "lucide-react";

const inputClass = (hasError: boolean) =>
  `w-full h-11 rounded-lg border bg-white px-4 pr-10 text-sm outline-none transition-colors focus:border-[#0FD131] focus:ring-2 focus:ring-[#9BFBE0] ${hasError ? "border-red-400" : "border-gray-300"}`;

const BankingDetails = ({ form }: { form: UseFormReturn<BankingDetailsFormData> }) => {
  const { register, formState } = form;

  return (
    <div className="space-y-5">
      <div className="relative">
        <h6 className="text-sm text-gray-500 mb-1">Bank name</h6>
        <input
          type="text"
          {...register("bankName")}
          className={inputClass(!!formState.errors.bankName)}
          placeholder="Enter your bank name"
        />
        <Pencil className="absolute right-3 top-9 size-3.5 text-gray-400 pointer-events-none" />
        {formState.errors.bankName && <p className="mt-1 text-sm text-red-500">{formState.errors.bankName.message}</p>}
      </div>
    </div>
  );
};

export default BankingDetails;
